import {BaseContainerModel} from '../base-container.model';
import { bl_catalog_login_subject_link_RowClass } from '../../dbschema';

export class UserCatalogContainerModel extends BaseContainerModel {
  bl_catalog_login_subject_link: bl_catalog_login_subject_link_RowClass = new bl_catalog_login_subject_link_RowClass();
}
